import { AuditAction, AuditLogDto, AuditResourceType } from '_lib/api';

export const DEFAULT_AUDIT_ITEMS_PER_PAGE = 30;
export const HISTORY_LIMIT = 20;

export interface AuditFilters {
  action: AuditAction | '';
  resourceType: AuditResourceType | '';
  username: string;
  resourceId: string;
  // ISO strings rather than Date objects so the store stays serialisable
  fromDate: string | null;
  toDate: string | null;
}

// One paginated result set. Unlike the other domains this holds a plain array instead of an
// entity adapter: audit rows are append-only, never arrive over WebSocket, are never looked
// up by id, and the server's createdAt DESC order is not overridable.
export interface AuditListState {
  loading: boolean;
  error: string | null;
  // Canonical query string of the request in flight, used to drop out-of-order responses
  queryKey: string | null;
  results: AuditLogDto[];
  total: number;
  // epoch ms, 0 means never loaded: this is what makes the history panel load lazily
  fetchedAt: number;
}

export interface AuditState {
  list: AuditListState;
  filters: AuditFilters;
  paginationCurrentPage: number;
  paginationItemsPerPage: number;
  history: Record<string, AuditListState>;
}

export const historyKey = (resourceType: AuditResourceType, resourceId: string): string =>
  `${resourceType}:${resourceId}`;

export const newAuditList = (): AuditListState => ({
  loading: false,
  error: null,
  queryKey: null,
  results: [],
  total: 0,
  fetchedAt: 0,
});

export const initialAuditFilters: AuditFilters = {
  action: '',
  resourceType: '',
  username: '',
  resourceId: '',
  fromDate: null,
  toDate: null,
};

// Stable reference for the history selector fallback. A fresh literal there would return a
// new object on every dispatch and re-render the detail panel on every store update.
export const EMPTY_AUDIT_LIST: AuditListState = newAuditList();
